import { createAction } from '@reduxjs/toolkit';

export const addProductTab = createAction('products-tab-menu/add');
export const removeProductTab = createAction('products-tab-menu/remove');
export const removeAllProductTabs = createAction('products-tab-menu/remove-all');
export const setActiveTabs = createAction('products-tab-menu/set-active');
